import { cn } from "~/lib/utils";

import type { ProductFeatureBlocksProps } from "./types";

/**
 * Stacked grey copy blocks under a product card (CM Enhanced Content design):
 * a medium-weight label over a light-weight line. Rows with neither a label
 * nor text are dropped so an untouched Builder row renders nothing.
 */
export function ProductFeatureBlocks({
  features,
  className,
  ...rest
}: ProductFeatureBlocksProps) {
  const rows = features.filter(f => f.label?.trim() || f.text?.trim());
  if (rows.length === 0) return null;
  return (
    <div
      className={cn("flex w-full flex-col gap-[8px] sm:gap-[12px]", className)}
      {...rest}
    >
      {rows.map((feature, i) => (
        <div
          key={`${feature.label ?? ""}-${i}`}
          className="flex min-h-[62px] w-full flex-col justify-center gap-[6px] bg-gray-01 p-[16px] font-grotesque text-[12px] leading-[1.5] text-blue-04 sm:min-h-[90px] sm:gap-[10px] sm:p-[24px] sm:text-[18px]"
        >
          {feature.label && <p className="font-medium">{feature.label}</p>}
          {feature.text && <p className="font-light">{feature.text}</p>}
        </div>
      ))}
    </div>
  );
}
